<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="md"
      centered
      hide-footer
      lazy
      @close="onCancel"
      @hidden="onModalHidden"
    >
      <template #modal-title>
        <div class="tw-text-lg tw-font-medium">
          {{ $t(`${user?.email ? "二次验证登录" : "绑定邮箱"}`) }}
        </div>
      </template>
      <b-tabs pills small justified @input="handleTabChange">
        <b-tab :title="$t('手机号码')" v-if="false">
          <b-form @submit.prevent="handleSubmit('phone')" class="mt-20">
            <b-form-group label-for="phone-input" class="mt-20">
              <b-form-input
                id="phone-input"
                v-model="formData.phone"
                type="tel"
                required
                :placeholder="$t('请输入手机号')"
              ></b-form-input>
            </b-form-group>
            <b-form-group label-for="phone-input" class="mt-20">
              <b-input-group>
                <b-form-input
                  id="phone-input"
                  v-model="formData.phoneCode"
                  type="tel"
                  :placeholder="$t('请输入验证码')"
                  required
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    :disabled="countdown.phone > 0"
                    @click="sendCode('phone')"
                  >
                    {{
                      countdown.phone > 0
                        ? `${countdown.phone}秒后重发`
                        : $t("发送验证码")
                    }}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-button
              class="mt-20"
              type="submit"
              variant="primary"
              :disabled="submitLoading"
              block
              style="width: 100%"
            >
              <b-spinner v-if="submitLoading" small></b-spinner>
              {{ $t("提交") }}
            </b-button>
          </b-form>
        </b-tab>

        <b-tab :title="$t('邮箱')">
          <b-form @submit.prevent="handleSubmit('email')" class="mt-20">
            <b-form-group label-for="email-input" class="mt-20">
              <b-form-input
                id="email-input"
                :value="user?.email ? formatEmail(user.email) : formData.email"
                @input="onEmailInput"
                type="email"
                required
                :disabled="!!user?.email"
                :placeholder="$t('请输入邮箱')"
              ></b-form-input>
            </b-form-group>
            <b-form-group label-for="email-code-input" class="mt-20">
              <b-input-group>
                <b-form-input
                  id="email-code-input"
                  v-model="formData.emailCode"
                  type="tel"
                  :placeholder="$t('请输入验证码')"
                  required
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    @click="sendCode('email')"
                    :disabled="countdown.email > 0"
                  >
                    {{
                      countdown.email > 0
                        ? `${countdown.email}秒后重发`
                        : $t("发送验证码")
                    }}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              v-if="user?.setGoogleAuth"
              label-for="google-code-input"
              class="mt-20"
            >
              <b-form-input
                id="google-code-input"
                v-model="formData.googleCode"
                type="tel"
                :placeholder="$t('请输入谷歌验证器')"
              ></b-form-input>
            </b-form-group>
            <b-button
              class="mt-20"
              type="submit"
              variant="primary"
              :disabled="submitLoading"
              block
              style="width: 100%"
            >
              <b-spinner v-if="submitLoading" small></b-spinner>
              {{ $t("提交") }}
            </b-button>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-modal>
    <!-- 在模板末尾添加验证组件 -->
    <Verification
      :visible.sync="showVerification"
      @verify-success="onVerifySuccess"
      @verify-cancel="onVerifyCancel"
    />
  </div>
</template>

<script>
import { isPhone, isEmail, formatEmail } from "@/utils/tools";
import { validSecondAuth } from "@/api/apiWord/index";
import { sendEmailApi, getUserInfoApi } from "@/api/modules/home";
import { bindEmailApi } from "@/api/personalCenter/index";
import Verification from "@/components/verification/verification.vue";
import { goToBlockWatch } from "@/utils/domain";

export default {
  name: "",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // 是否由父组件控制关闭（用于路由守卫场景）
    externalControl: {
      type: Boolean,
      default: false,
    },
  },
  components: { Verification },
  data() {
    return {
      formatEmail,
      submitLoading: false,
      formData: {
        phone: "",
        email: "",
        // 手机验证码
        phoneCode: "",
        // 邮箱验证码
        emailCode: "",
        // 谷歌验证器
        googleCode: "",
      },
      // 倒计时秒数
      countdown: {
        phone: 0,
        email: 0,
      },
      // 定时器
      timer: null,
      // 用户信息
      user: {},
      showVerification: false,
      pendingSendType: "",
    };
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  created() {},
  watch: {
    // 监听 show 属性变化，当弹窗打开时重新获取用户信息
    show: {
      handler(newVal) {
        if (newVal) {
          // 当 show 变为 true 时（弹窗打开）
          this.refreshUserInfo();
        }
      },
      immediate: false,
    },
  },
  methods: {
    refreshUserInfo() {
      this.user = JSON.parse(localStorage.getItem("userInfo"));
      this.formData.email = this.user?.email || "";
    },
    // 方法区
    onCancel() {
      this.$emit("close");
    },
    // 切换tabs
    handleTabChange(index) {
      if (index === 0) {
        this.formData.phoneCode = "";
      } else if (index === 1) {
        this.formData.emailCode = "";
      }
    },
    // 发送验证码
    async sendCode(type) {
      // 如果已经有倒计时，禁止重复点击
      if (this.countdown[type] > 0) return;

      const validators = {
        phone: this.validatePhone,
        email: this.validateEmail,
      };
      // 在 sendCode 方法中调用
      if (!validators[type]()) return;

      // 保存当前发送类型，打开验证窗口
      this.pendingSendType = type;
      this.showVerification = true;
    },

    // 验证成功后的回调
    async onVerifySuccess() {
      const type = this.pendingSendType;
      try {
        let params = {
          email: this.formData.email,
        };
        // 如果没有邮箱则绑定邮箱
        if (!this.user.email) {
          params.type = 2; //绑定
        } else {
          params.type = 3; // 二次验证登录;
        }
        const { code, message } = await sendEmailApi(params);
        if (code !== 0)
          return this.$toast(this.$t(message), {
            type: "center",
            timeout: 2000,
            closeOnClick: false,
          });
        this.$toast(this.$t("验证码已发送"), {
          type: "center",
          timeout: 1000,
        });
        // 启动倒计时
        this.countdown[type] = 60;

        // 启动定时器
        if (!this.timer) {
          this.timer = setInterval(() => {
            if (this.countdown[type] > 0) this.countdown[type]--;
            if (this.countdown.phone <= 0 && this.countdown.email <= 0) {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } catch (error) {
        this.$toast(this.$t("网络异常"), { timeout: 1000 });
      } finally {
        this.pendingSendType = "";
      }
    },

    // 验证取消的回调
    onVerifyCancel() {
      this.pendingSendType = "";
    },
    // 提交
    async handleSubmit(type) {
      const validators = {
        phone: this.validatePhone,
        email: this.validateEmail,
      };
      // 在 sendCode 方法中调用
      if (!validators[type]()) return;
      try {
        this.submitLoading = true;
        // 如果没邮箱则先绑定
        if (!this.user.email) {
          await this.handleBindSubmit();
          return;
        }

        let submitData = {};
        submitData = {
          email: this.formData.email,
          emailCode: this.formData.emailCode,
          googleCode: this.formData.googleCode,
        };
        const { code, message } = await validSecondAuth(submitData);
        if (code !== 0) return this.handleTip(message);
        this.handleTip("验证成功");
        this.$store.commit("SET_VERIFICATION", "1");
        // 触发验证成功事件，由路由守卫处理导航
        this.$emit("verify-success");
        // 如果不是外部控制，则关闭弹窗
        if (!this.externalControl) {
          this.modalShow = false;
          // this.$router.push("/apiWord/api-console");
          goToBlockWatch("/apiWord/api-console");
        }
      } finally {
        this.submitLoading = false;
      }
    },
    // 绑定邮箱
    async handleBindSubmit() {
      const data = {
        email: this.formData.email,
        emailCode: this.formData.emailCode,
      };

      const { code, message } = await bindEmailApi(data);
      if (code !== 0) return this.handleTip(message);
      await this.getUser();
      // 重新获取用户信息以获取最新的
      this.refreshUserInfo();
      this.onModalHidden(false);
      this.$toast(this.$t("邮箱绑定成功，请继续完成二次验证"), {
        type: "center",
        timeout: 2000,
        closeOnClick: false,
      });
    },
    // 获取用户信息
    async getUser() {
      const { code, message, data } = await getUserInfoApi();
      if (code !== 0) return this.handleTip(message);
      //  暂时保存用户信息
      localStorage.setItem("userInfo", JSON.stringify(data));
    },
    // 关闭登录弹窗销毁数据
    onModalHidden(close = true) {
      // 清除表单数据
      this.formData = {
        phone: "",
        email: this.user?.email || "",
        phoneCode: "",
        emailCode: "",
      };

      // 重置倒计时
      this.countdown = {
        phone: 0,
        email: 0,
      };

      // 清除定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (close) {
        this.$emit("close");
      }
    },
    // 验证手机号
    validatePhone() {
      if (!isPhone(this.formData.phone)) {
        this.handleTip("请输入正确的手机号码");
        return false;
      }
      return true;
    },
    // 验证邮箱
    validateEmail() {
      if (!isEmail(this.formData.email)) {
        this.handleTip("请输入正确的邮箱");
        return false;
      }
      return true;
    },

    // 处理邮箱输入事件
    onEmailInput(value) {
      // 只有在用户没有邮箱时才更新 formData.email
      if (!this.user?.email) {
        this.formData.email = value;
      }
    },
    handleTip(message) {
      this.$toast(this.$t(message), {
        type: "center",
        timeout: 1000,
        closeOnClick: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  padding: 0 0px 20px 0px;
  box-sizing: border-box;
}
::v-deep .nav-pills {
  width: 200px;
  font-size: 16px !important;
}

::v-deep .nav-pills .nav-link {
  /* font-size: 18px; */
  /* width: 120px; */
  width: fit-content;
  color: black;
  padding: 0;
}

::v-deep .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #0b5ed7;
  font-weight: bold;
  background: #fff;
  position: relative;
  text-decoration: solid underline #0b5ed7;
  text-decoration-thickness: 2px;
  text-underline-offset: 12px;
}
</style>
